import React from "react";
import { Link } from "react-router";
import SignupForm from "./SignupForm";
import useAuthActions from "../hooks/useAuthActions";

const SignupPage = () => {
  const { attemptSignup } = useAuthActions();

  const onSubmit = (formValues: any) => {
    attemptSignup(formValues);
  };

  return (
    <div>
      <div className="max-w-2xl mx-auto px-4">
        <h1 className="text-3xl font-bold my-4">KilnHelper Signup</h1>
        <SignupForm onSubmit={onSubmit} />
        <h3 className="text-lg font-semibold mt-6 mb-2">
          Existing User? <Link to="/login">Login</Link>
        </h3>
      </div>
    </div>
  );
};

export default SignupPage;
